import { render, staticRenderFns } from "./InputJson.vue?vue&type=template&id=52138145&scoped=true&"
import script from "./InputJson.vue?vue&type=script&lang=js&"
export * from "./InputJson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52138145",
  null
  
)

export default component.exports